import category from '@/data/select/searchBarCategoryLang';

export const buildProfessionalServiceQuery = (search: string): string => {
  const params = new URLSearchParams(search);

  if (!params.get('category')?.trim()) {
    // Search labels use "Accounting and Taxation"; stored company categories use "Accounting".
    const defaultCategories = category.en.map((value) => (value === 'Accounting and Taxation' ? 'Accounting' : value));
    params.set('category', defaultCategories.join(','));
  }

  return `?${params.toString()}`;
};
